import { Link } from 'react-router-dom';

const STEPS = [
  {
    n: '01',
    title: 'Pick your category',
    desc: 'Work, Social, Family, Dating, Errands, or Other. Each one gets a slightly different calibration of regret.',
  },
  {
    n: '02',
    title: 'Describe the situation',
    desc: "The more specific, the better. We don't need names — just enough context to write something that sounds like you thought about it.",
  },
  {
    n: '03',
    title: 'Get three excuses',
    desc: "A soft boundary, a personal truth, and a chaos card. Pick the one that fits your energy. Refine it if it's not quite right.",
  },
  {
    n: '04',
    title: 'Copy and send',
    desc: "Paste it into your message. You're done. The obligation has been tactfully dodged.",
  },
];

export default function HowItWorks() {
  return (
    <div>
      <section className="pad-x" style={{ padding: '80px 40px 60px', maxWidth: 680 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.14em',
            color: 'var(--tag)',
            marginBottom: 24,
            textTransform: 'uppercase',
          }}
        >
          How it works
        </div>
        <h1
          className="hero-title"
          style={{
            fontSize: 48,
            fontWeight: 700,
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
            marginBottom: 20,
          }}
        >
          Four steps.
          <br />
          Zero guilt.
        </h1>
        <p
          style={{
            fontSize: 15,
            color: 'var(--fg-muted)',
            lineHeight: 1.7,
            maxWidth: 400,
          }}
        >
          ImNotGoing is not a lie generator. It's a clarity tool. It helps you
          say what you already know — that you can't make it — with exactly the
          right amount of explanation.
        </p>
      </section>

      <div style={{ height: 1, background: 'var(--border)' }} />

      <section
        className="pad-x"
        style={{
          padding: '60px 40px 80px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 2,
        }}
      >
        {STEPS.map((step) => (
          <div
            key={step.n}
            style={{
              padding: '40px 36px',
              border: '1px solid var(--border)',
              margin: '-1px 0 0 -1px',
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.12em',
                color: 'var(--tag)',
                marginBottom: 20,
              }}
            >
              {step.n}
            </div>
            <h3
              style={{
                fontSize: 22,
                fontWeight: 600,
                letterSpacing: '-0.02em',
                marginBottom: 12,
              }}
            >
              {step.title}
            </h3>
            <p
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                color: 'var(--fg-muted)',
                textWrap: 'pretty',
              }}
            >
              {step.desc}
            </p>
          </div>
        ))}
      </section>

      <div
        className="pad-x"
        style={{ padding: '0 40px 80px', display: 'flex', gap: 16, flexWrap: 'wrap' }}
      >
        <Link
          to="/"
          style={{
            padding: '14px 28px',
            background: 'var(--accent)',
            borderRadius: 6,
            fontSize: 14,
            fontWeight: 600,
            color: '#0f0f0f',
            textDecoration: 'none',
          }}
        >
          Generate an excuse →
        </Link>
        <Link
          to="/hall-of-fame"
          style={{
            padding: '14px 28px',
            background: 'transparent',
            border: '1px solid var(--border)',
            borderRadius: 6,
            fontSize: 14,
            fontWeight: 400,
            color: 'var(--fg-muted)',
            textDecoration: 'none',
          }}
        >
          See the hall of fame
        </Link>
      </div>

      <footer
        className="pad-x"
        style={{
          borderTop: '1px solid var(--border)',
          padding: '20px 40px',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 20,
          flexWrap: 'wrap',
        }}
      >
        <span
          style={{
            fontSize: 13,
            color: 'var(--tag)',
            fontStyle: 'italic',
          }}
        >
          "You're not flaky. You're just honest about your limits."
        </span>
      </footer>
    </div>
  );
}
